import { type SelectValueChangeDetails } from "@ark-ui/react";
import {
  ALL_INDEPENDENCE_LEVELS,
  type FimItem,
  IndependenceLevel,
  parseIndependenceLevel,
} from "@packages/core";
import { useCallback, useMemo } from "react";
import { type Merge } from "type-fest";
import { useTranslate } from "../../services";
import { DropDownList2, type DropDownList2Properties } from "../form-fields";

export type IndependenceLevelSelectorProperties = Merge<
  DropDownList2Properties,
  {
    options?: never;
    fimItem: FimItem;
    onChange?: { (value: IndependenceLevel): void };
    onError?: { (error: unknown): void };
    value?: IndependenceLevel;
  }
>;

export function IndependenceLevelSelector({
  fimItem,
  onChange,
  onError,
  value,
  ...properties
}: IndependenceLevelSelectorProperties) {
  const translate = useTranslate();

  return (
    <DropDownList2
      {...properties}
      onValueChange={useCallback(
        function (event: SelectValueChangeDetails) {
          const value = event.value.at(0);
          if (typeof onChange === "function" && typeof value === "string") {
            try {
              onChange(parseIndependenceLevel(Number.parseInt(value)));
            } catch (error) {
              console.debug("IndependenceLevelの解析に失敗しました。", error, event);
            }
          }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
      )}
      options={useMemo(
        function () {
          return ALL_INDEPENDENCE_LEVELS.map(function (independenceLevel) {
            return {
              label: translate("%IndependenceLevel." + independenceLevel + ".0%"),
              value: independenceLevel.toString(),
              description: translate(
                "%FimItem." + fimItem + ".IndependenceLevel." + independenceLevel + ".0%",
              ),
            };
          });
        },
        [fimItem, translate],
      )}
      value={useMemo(
        function () {
          return [String(value)];
        },
        [value],
      )}
    />
  );
}
